__turbopack_context__.v({
  "decor": "ProgramSubjectNav-module__R9a04W__decor",
  "decorDot": "ProgramSubjectNav-module__R9a04W__decorDot",
  "decorRow": "ProgramSubjectNav-module__R9a04W__decorRow",
  "desktopNav": "ProgramSubjectNav-module__R9a04W__desktopNav",
  "dropdown": "ProgramSubjectNav-module__R9a04W__dropdown",
  "dropdownChevron": "ProgramSubjectNav-module__R9a04W__dropdownChevron",
  "dropdownFieldLabel": "ProgramSubjectNav-module__R9a04W__dropdownFieldLabel",
  "dropdownItem": "ProgramSubjectNav-module__R9a04W__dropdownItem",
  "dropdownList": "ProgramSubjectNav-module__R9a04W__dropdownList",
  "dropdownOption": "ProgramSubjectNav-module__R9a04W__dropdownOption",
  "dropdownOptionInner": "ProgramSubjectNav-module__R9a04W__dropdownOptionInner",
  "dropdownOptionSubtitle": "ProgramSubjectNav-module__R9a04W__dropdownOptionSubtitle",
  "dropdownOptionText": "ProgramSubjectNav-module__R9a04W__dropdownOptionText",
  "dropdownOptionTitle": "ProgramSubjectNav-module__R9a04W__dropdownOptionTitle",
  "dropdownTrigger": "ProgramSubjectNav-module__R9a04W__dropdownTrigger",
  "dropdownTriggerContent": "ProgramSubjectNav-module__R9a04W__dropdownTriggerContent",
  "dropdownTriggerOpen": "ProgramSubjectNav-module__R9a04W__dropdownTriggerOpen",
  "dropdownValue": "ProgramSubjectNav-module__R9a04W__dropdownValue",
  "icon": "ProgramSubjectNav-module__R9a04W__icon",
  "item": "ProgramSubjectNav-module__R9a04W__item",
  "label": "ProgramSubjectNav-module__R9a04W__label",
  "link": "ProgramSubjectNav-module__R9a04W__link",
  "linkActive": "ProgramSubjectNav-module__R9a04W__linkActive",
  "list": "ProgramSubjectNav-module__R9a04W__list",
  "nav": "ProgramSubjectNav-module__R9a04W__nav",
  "row": "ProgramSubjectNav-module__R9a04W__row",
  "subtitle": "ProgramSubjectNav-module__R9a04W__subtitle",
  "text": "ProgramSubjectNav-module__R9a04W__text",
  "title": "ProgramSubjectNav-module__R9a04W__title",
});
